export default {"src":"/_next/static/media/star.7be6a090.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};